// extracted by mini-css-extract-plugin
module.exports = {"svg":"logotype_svg__3fGRy"};